/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentPropertiesViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    $routeParams: JS5Object,
    $route: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    ContentEditService: JS5Object,
    DynamicPropertiesService: JS5Object,
    EnumService: JS5Object,
    LanguagesService: JS5Object,
    MediaAcceptProfileService: JS5Object,
    ModalService: JS5Object,
    NotificationService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
    TerritoriesService: JS5Object,
    TranslatableMetadataService: JS5Object,
) {

    this.editData = {};
    this.availableTerritories = [];

    const getData = () => {
        let promises = [];
        this.loadingIndicator.show = true;
        promises.push(PermissionsService.isSystemOperator()
            .then((isSystemOperator: boolean) => {
                this.canWriteLiveFeeds = isSystemOperator;
            }));
        promises.push(EnumService.queryForEnums()
            .then(() => {
                ContentEditService.setAvailableBreakPatterns();
                this.availableBreakPatterns = ContentEditService.availableBreakPatterns;

                this.contentObject.breakPrePostRollPattern =
                    _.filter(ContentEditService.availableBreakPatterns, (pattern) => {
                        if (pattern.id === this.contentObject.breakPrePostRollPattern) {
                            return pattern;
                        }
                    })[0];

                this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
            }));
        // get the available territories
        promises.push(TerritoriesService.getAllTerritories({fetchLimit: 0, includeHidden: false})
            .then((territories) => {
                // Place USA at the top of the list
                const territoriesWithUsaFirst = _.chain(territories)
                    .partition({name: 'USA'})
                    .flatten()
                    .value();
                _.set(this, 'availableTerritories', territoriesWithUsaFirst);
            }));
        promises.push(LanguagesService.getAllLanguagesSorted()
            .then((languages: JS5Object) => {
                this.languages = languages;
            }));
        promises.push(DynamicPropertiesService.queryForProperties());

        return $q.all(promises).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.$onInit = () => {
        SidebarService.editService = ContentEditService;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.selectedFeeds = [];

        getData().then(() => {
            this.maxValueLength = DynamicPropertiesService.getPropValueAsInt('content.maxValueLength', -1);
            this.maxShortDescLength = DynamicPropertiesService.getPropValueAsInt('content.maxShortDescLength', -1);
            this.maxLongDescLength = DynamicPropertiesService.getPropValueAsInt('content.maxLongDescLength', -1);
            this.maxKeywordsLength = DynamicPropertiesService.getPropValueAsInt('content.maxKeywordsLength', -1);


            $timeout(() => {
                let requiredFields: string[];


                if (ContentEditService.contentObject.type === 'Series') {
                    requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.content.series.required.properties', []);
                } else if (ContentEditService.contentObject.type === 'Movie/Special') {
                    requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.content.movieSpecial.required.properties', []);
                }

                this.translatableMetadataFields = [
                    {
                        name: 'value',
                        title: 'Value',
                        maxChars: this.maxValueLength,
                        required: _.includes(requiredFields, 'value'),
                    },
                    {
                        name: 'shortDescription',
                        title: 'Short Description',
                        maxChars: this.maxShortDescLength,
                        required: _.includes(requiredFields, 'shortDescription'),
                    },
                    {
                        name: 'longDescription',
                        title: 'Long Description',
                        maxChars: this.maxLongDescLength,
                        required: _.includes(requiredFields, 'longDescription'),
                    },
                    {
                        name: 'keywords',
                        title: 'Auto Keywords',
                        type: 'multi',
                        maxChars: this.maxKeywordsLength,
                        required: _.includes(requiredFields, 'keywords'),
                    },
                ];
            });

        });
    };

    this.liveFeedGridColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: '<div class="ui-grid-cell-contents" col-index="renderIndex" ng-click="grid.appScope.contentPropCtrlr.toggleRows($event)">' +
            '<input type="checkbox" ng-checked="grid.selection.selectAll"/><label></label></div>'
        },
        {
            field: 'liveFeed.name',
            name: 'Live Feed',
            sortable: false,
            enableColumnMenu: false
        },
        {
            field: 'timezoneOffset',
            name: 'Eastern Timezone Offset (minutes)',
            width: 250,
            sortable: false,
            enableColumnMenu: false
        },
        {
            field: 'defaultFlag',
            name: 'Default',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            width: 70,
            cellTemplate: 'components/visual/grid/boolean-flag-template.html'
        }
    ];

    this.liveFeedsGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: false,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 4,
        enableVerticalScrollbar: 2,
        columnDefs: this.liveFeedGridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: (gridApi) => {
            this.gridApi = gridApi;
            this.gridApi.selection.on.rowSelectionChanged(null, this.gridRowSelectionChangedHandler);
        }
    };

    this.gridRowSelectionChangedHandler = (row) => {
        if (row.isSelected) {
            this.selectedFeeds.push(row.entity);
        } else {
            var index = this.selectedFeeds.indexOf(row.entity);
            this.selectedFeeds.splice(index, 1);
        }
    };

    this.toggleRows = (evt) => {
        if (this.gridApi.selection.selectAll) {
            this.gridApi.selection.clearSelectedRows(evt);
            this.gridApi.selection.selectAll = false;
        } else {
            this.gridApi.selection.selectAllVisibleRows(evt);
            this.gridApi.selection.selectAll = true;
        }

        this.selectedFeeds = this.gridApi.selection.getSelectedRows();
    };

    this.addFeed = (feed) => {
        if (!ContentEditService.contentObject.liveFeeds) {
            ContentEditService.contentObject.liveFeeds = [];
        }
        ContentEditService.contentObject.liveFeeds.push(feed);
        this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
        this.editorForm.$setDirty();
    };

    this.removeSelectedFeeds = () => {
        _.remove(ContentEditService.contentObject.liveFeeds, (liveFeed) => {
            return this.selectedFeeds.indexOf(liveFeed) >= 0;
        });

        this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
        this.editorForm.$setDirty();
    };

    this.canRemoveSelected = () => {
        var canRemove = this.selectedFeeds.length > 0;
        _.forEach(this.selectedFeeds, (feed) => {
            if (!feed.canBeDeleted) {
                canRemove = false;
            }
        });
        return canRemove;
    };

    this.addShowLiveFeed = () => {
        ModalService.showAddLiveFeedModal(
            this.availableLiveFeeds,
            {
                liveFeed: null,
                timezoneOffset: ''
            },
            this.addFeed);
    };

    this.editShowLiveFeed = (liveFeed) => {
        ModalService.showAddLiveFeedModal(
            this.availableLiveFeeds,
            liveFeed,
            this.editorForm.$setDirty);
    };

    this.onRowDblClick = (row) => {
        this.editShowLiveFeed(row.entity);
    };

    this.resetContentData = () => {
        this.contentObject = ContentEditService.contentObject;
        this.metadataComponentsMap = ContentEditService.metadataComponentsMap;
        this.liveFeedsGridOptions.data = ContentEditService.contentObject.liveFeeds;
    };

    this.toggleContentLock = () => {
        this.editorForm.$setDirty();
    };

    var convertBreakPattern = () => {
        ContentEditService.contentObject.breakPrePostRollPattern =
            _.filter(ContentEditService.availableBreakPatterns, (pattern) => {
                if (pattern.id === ContentEditService.contentObject.breakPrePostRollPattern) {
                    return pattern;
                }
            })[0];
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => {
                let enableSave = false;
                if (_.get(this, 'contentObject.type') === 'Ad/PreRoll') {
                    enableSave = !_.get(this.editorForm, '$pristine') &&
                        !!_.get(this.contentObject, 'name') &&
                        !!_.get(this.contentObject, 'network') &&
                        !!_.get(this.contentObject, 'originalLanguage');
                } else {
                    enableSave = !_.get(this.editorForm, '$pristine') &&
                        !!_.get(this.contentObject, 'name') &&
                        !!_.get(this.contentObject, 'network') &&
                        !!_.get(this.contentObject, 'originalLanguage') &&
                        !!_.get(this.contentObject, 'territory');
                }
                return enableSave;
            },
            onClick: () => {
                this.loadingIndicator.show = true;

                if (typeof this.contentObject.breakPrePostRollPattern === 'object') {
                    this.contentObject.breakPrePostRollPattern = this.contentObject.breakPrePostRollPattern.id;
                }

                TranslatableMetadataService.preSave();

                ContentEditService.saveEditData().then(() => {
                    convertBreakPattern();
                    this.contentObject = ContentEditService.contentObject;
                    TranslatableMetadataService.dataObjectSaved(this.contentObject);
                    this.loadingIndicator.show = false;
                    this.editorForm.$setPristine();
                });
            }
        },
        {
            label: 'Revert',
            enabled: () => _.get(this.editorForm, '$dirty'),
            onClick: () => {
                ContentEditService.revertEditData();
                convertBreakPattern();
                this.contentObject = ContentEditService.contentObject;
                TranslatableMetadataService.dataObjectReverted(this.contentObject);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => true,
            onClick: () => {
                ContentEditService.exitEdit();
            }
        }
    ];

    ContentEditService.tabRevertFunction = this.resetContentData;
    ContentEditService.tabSaveSuccessFunction = this.resetContentData;
    ContentEditService.tabSaveErrorFunction = this.resetContentData;

    this.$onDestroy = () => {
        ContentEditService.originalEditData = null;
        ContentEditService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            ContentEditService.editorForm = this.editorForm;
            BreadcrumbService.editService = ContentEditService;
            TranslatableMetadataService.setDataObject(ContentEditService.contentObject);
        });
    };
}


angular.module('prism-ui.content').component('contentPropertiesView', {
    templateUrl: 'meta/content/editor/components/view/properties/content-properties-view-template.html',
    controller: ContentPropertiesViewController,
    bindings: {
        contentObject: '<',
        genres: '<',
        networks: '<',
        metadataComponentsMap: '<',
        availableLiveFeeds: '<'
    }
});
